export const faceEvalResult = {
  liveWeight: 0,
  weights: null,
  // The face graph's play requests (evaluateGraph().plays) — one per Play Clip
  // node, each its own playhead in FaceClipPlayer.getBlendedWeights.
  plays: null,
}
